import React, { useMemo } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { themeSettings } from "theme";
import PrivateRoute from "state/PrivateRoute";
import RoleBasedRoute from "state/RoleBasedRoute";

import Login from "scene/Login";
import Layout from "scene/Layout";
import MrDashboard from "scene/Mr";
import RxTracker from "scene/Mr/RxTracker";
import WeeklyTracker from "scene/Mr/WeeklyTracker";
import PspTracker from "scene/Mr/PspTracker";
import LycoredTracker from "scene/Mr/LycoredTracker";
import MySubmissions from "scene/Mr/MySubmissions";
import AmDashboard from "scene/Am";
import MrList from "scene/Am/MrList";
import AmDetails from "scene/Amdetails";
import AdminDashboard from "scene/Admin";
import UserManagement from "scene/Admin/UserManagement";
import AllSubmissions from "scene/Admin/AllSubmissions";
import Exports from "scene/Admin/Exports";

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              {/* MR Routes */}
              <Route element={<RoleBasedRoute allowedRoles={["MR"]} />}>
                <Route path="/" element={<Navigate to="/mr/dashboard" replace />} />
                <Route path="/mr/dashboard" element={<MrDashboard />} />
                <Route path="/mr/rx-tracker" element={<RxTracker />} />
                <Route path="/mr/weekly-tracker" element={<WeeklyTracker />} />
                <Route path="/mr/psp-tracker" element={<PspTracker />} />
                <Route path="/mr/lycored-tracker" element={<LycoredTracker />} />
                <Route path="/mr/my-submissions" element={<MySubmissions />} />
              </Route>

              {/* AM Routes */}
              <Route element={<RoleBasedRoute allowedRoles={["AM"]} />}>
                <Route path="/am/dashboard" element={<AmDashboard />} />
                <Route path="/am/mr-list" element={<MrList />} />
                <Route path="/am/mr-details/:mrMgCd" element={<AmDetails />} />
              </Route>

              {/* Admin Routes */}
              <Route element={<RoleBasedRoute allowedRoles={["Admin"]} />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<UserManagement />} />
                <Route path="/admin/submissions" element={<AllSubmissions />} />
                <Route path="/admin/exports" element={<Exports />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
